import { vars } from "../css/vars.css";

export type Breakpoints = string[];

export type MediaQueries = {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
  
  _sm: string;
  _md: string;
  _lg: string;
  _xl: string;
  _xxl: string;
};

export type Spacing = number[];

export type Radii = {
  small: string;
  default: string;
  card: string;
  circle: string;
};

export type Shadows = {
  level1: string;
  active: string;
  success: string;
  warning: string;
  focus: string;
  inset: string;
  tooltip: string;
};

export type Colors = typeof vars.colors;

export type ZIndices = {
  ribbon: number;
  dropdown: number;
  modal: number;
};
